<!--
 * @Author: sueRimn
 * @Date: 2021-04-01 14:57:00
 * @LastEditors: sueRimn
 * @LastEditTime: 2021-04-06 17:19:43
-->
<!--  -->
<template>
  <div class="footer_Button">
    <div
      class="footer_Button_right"
      :style="{width: !right ? '100%' : '170px'}"
      @click="leftNext()"
    >
      {{left}}
    </div>
    <div
      v-if="right"
      class="footer_Button_left"
      @click="rightNext()"
    >
      {{right}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterTwoButton',
  props: ['left', 'right', 'leftNext', 'rightNext'],
  data() {
    return {};
  },
  mounted() {
    console.log(this);
  },
};
</script>
<style scoped>
.footer_Button {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 16px;
}
.footer_Button_left {
  width: 155px;
  height: 40px;
  background-image: linear-gradient(180deg, #f5514a 2%, #f5683c 99%);
  border: 1px solid #ff6538;
  border-radius: 4px;
  color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}

.footer_Button_right {
  width: 170px;
  height: 40px;
  /* background: #ffffff; */
  background-image: linear-gradient(180deg, #f5514a 2%, #f5683c 99%);
  border: 1px solid #ff6538;
  border-radius: 4px;
  color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
</style>
